import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTextboxMultiple = () => {
  return (
    <g>
      <path d="m15.1563 1.5332h-14.3125a.75.75 0 0 0 -.75.75v4.2468a.75.75 0 0 0 .75.75h14.3125a.75.75 0 0 0 .75-.75v-4.2468a.75.75 0 0 0 -.75-.75zm-.75 4.2471h-12.8125v-2.7471h12.8125z" />
      <path d="m15.1563 8.72h-14.3125a.75.75 0 0 0 -.75.75v4.2471a.75.75 0 0 0 .75.75h14.3125a.75.75 0 0 0 .75-.75v-4.2471a.75.75 0 0 0 -.75-.75zm-.75 4.2471h-12.8125v-2.7471h12.8125z" />
    </g>
  );
};

export default withIcon(IconTextboxMultiple);
